import AddEditContactModal from './AddEditContactModal';

export default AddEditContactModal;
